import {actionTypes} from '@servicenow/ui-internal';

export const DISPATCH_EVENT = 'DISPATCH_CUSTOM_EVENT';
export const COMPONENT_ID_ATTRIBUTE = 'component-id';
export const ATTRIBUTE_SET = 'ATTRIBUTE_SET';
export const STORE_UPDATED = 'STORE_UPDATED';
export const HANDLE_ACTIONS = 'handle-actions';
export const PROPERTIES_SET = 'PROPERTIES_SET';
export const SHOULD_NOT_PROPAGATE = [PROPERTIES_SET, STORE_UPDATED];
export const PARSE_PROP_CONF_KEY = 'unstableParse';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const COMPONENT_NAME_ATTR = 'component-name';
export const COMPONENT_NAME_PROP = 'componentName';
export const HOIST_APPEND_TO_PROP = 'hoistAppendTo';
export const HOIST_APPEND_TO_ATTR = 'hoist-append-to';
export const HOIST_ATTR = 'hoist';
export const SEISMIC_HOIST_TAG_NAME = 'SEISMIC-HOIST';
export const HOIST_FIRST_SCROLL_PARENT = 'now-unstable-first-scroll-parent';
export const DEFER_ATTRIBUTE = 'defer';
export const APPEND_TO_PAYLOAD_PROP_NAME = 'appendToPayload';
export const APPEND_TO_META_PROP_NAME = 'appendToMeta';
export const PROPERTY_SELECTOR_SIGIL = '@';
export const PROPERTIES_SET_LIFECYCLE = 'onPropertiesSet';

// legacy life cycle functions
export const ON_CONNECT_LIFECYCLE = 'onConnect';
export const ON_DISCONNECT_LIFECYCLE = 'onDisconnect';
export const ON_BOOTSTRAP_LIFECYCLE = 'onBootstrap';

// public action types
export const {COMPONENT_CONNECTED} = actionTypes;
export const {COMPONENT_DISCONNECTED} = actionTypes;
export const {COMPONENT_BOOTSTRAPPED} = actionTypes;
export const {COMPONENT_PROPERTY_CHANGED} = actionTypes;
export const {COMPONENT_RENDERED} = actionTypes;
export const {COMPONENT_DOM_READY} = actionTypes;
export const {COMPONENT_PROPERTY_UPDATE_REQUESTED} = actionTypes;
export const {COMPONENT_RENDER_REQUESTED} = actionTypes;
export const {COMPONENT_DOM_TREE_READY} = actionTypes;
export const {COMPONENT_TREE_RENDERED} = actionTypes;
export const {COMPONENT_ACTION_DISPATCHED} = actionTypes;
export const {COMPONENT_INTERACTIVE} = actionTypes;

// now namespace
export const NOW_HOIST_ATTR = 'now-hoist';
export const NOW_HOIST_PROP = 'nowHoist';
export const NOW_HOIST_APPEND_TO_ATTR = 'now-hoist-append-to';
export const NOW_HOIST_PREPEND_TO_ATTR = 'now-hoist-prepend-to';
export const NOW_HOIST_APPEND_TO_PROP = 'nowHoistAppendTo';
export const NOW_HOIST_PREPEND_TO_PROP = 'nowHoistPrependTo';
export const NOW_ID_ATTR = 'now-id';
export const NOW_ID_PROP = 'nowId';
export const NOW_COMPONENT_NAME_ATTR = 'now-name';
export const NOW_COMPONENT_NAME_PROP = 'nowName';
export const NOW_ENABLE_PROPERTY_SETTING_PREVENTION_ATTR = 'now-enable-property-setting-prevention';
export const NOW_ENABLE_PROPERTY_SETTING_PREVENTION_PROP = 'nowEnablePropertySettingPrevention';
export const NOW_LOGGING_LEVELS_PROP = 'nowLoggingLevels';
export const NOW_PLACEHOLDER_HEIGHT_PROP = 'nowPlaceholderHeight';
export const NOW_PLACEHOLDER_WIDTH_PROP = 'nowPlaceholderWidth';

// priorities
export const NOW_PRIORITY_ATTR = 'now-priority';
export const NOW_PRIORITY_PROP = 'nowPriority';
export const PRIORITY_LEVEL_LOW = 'low';
export const PRIORITY_LEVEL_MEDIUM = 'medium';

// modes
export const NOW_MODE_ATTR = 'now-mode';
export const NOW_MODE_PROP = 'nowMode';
export const COMPONENT_MODE_ACTIVE = 'active';
export const COMPONENT_MODE_SUSPEND = 'suspend';
export const COMPONENT_MODE_DETACH = 'detach';

// metrics
export const NOW_METRIC_TYPES_PROP = 'nowMetricTypes';
export const NOW_METRICS_LEVEL_PROP = 'nowMetricsLevel';

export const NOW_UI_EVENT = 'NOW_UI_EVENT';
// now event types
export const STATE_UPDATED = 'STATE_UPDATED';
export const ACTION_DISPATCHED = 'ACTION_DISPATCHED';
export const ACTION_HANDLED = 'ACTION_HANDLED';
export const PROPAGATION_STOPPED = 'PROPAGATION_STOPPED';
export const DEFAULT_PREVENTED = 'DEFAULT_PREVENTED';

export const SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED =
	'SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED';
export const COMPONENT_INTERNAL_ACTION = 'NOW_COMPONENT_INTERNAL_ACTION';

export const HELPERS_IMMEDIATE = 'HELPERS_IMMEDIATE';
export const HELPERS_DEFER = 'HELPERS_DEFER';
export const HELPERS_SCHEDULED = 'HELPERS_SCHEDULED';
export const PACKAGE_NAME = '@servivcenow/ui-core';

export const SHADOW_ROOT_MODE_CLOSED = 'closed';
export const SHADOW_ROOT_MODE_OPEN = 'open';

export const COMPONENT_STATE_UPDATED = 'SEISMIC_COMPONENT_STATE_UPDATED';

// Avoid re-render prop used to avoid component re-render if new & old states are same
export const NOW_AVOID_RENDER_PROP = 'nowAvoidRender';

export const ARIA_LIVE_REGION_UPDATE_REQUESTED = 'SEISMIC_ARIA_LIVE_REGION_UPDATE_REQUESTED';
export const ARIA_LIVE_POLITE = 'polite';
export const ARIA_LIVE_ASSERTIVE = 'assertive';

export const SPAN_KIND_CLIENT = 3;
export const SPAN_FOR_RENDER = 'RENDER';
export const SPAN_FOR_ACTION_HANDLED = 'ACTION_HANDLE';
export const SPAN_FOR_DISPATCH = 'ACTION_DISPATCH';
export const SPAN_FOR_UPDATE_PROPERTIES = 'UPDATE_PROPERTIES';
export const SPAN_FOR_SET_PROPERTY = 'SET_PROPERTY';

export const SPAN_FOR_UPDATE_STATE = 'UPDATE_STATE';
export const SPAN_FOR_UPDATE_CONTEXT = 'UPDATE_CONTEXT';

export const SPAN_FOR_COMPONENT_CONNECTED = 'CONNECTED';
export const SPAN_FOR_COMPONENT_DISCONNECTED = 'DISCONNECTED';
export const SPAN_FOR_COMPONENT_BOOTSTRAPPED = 'BOOTSTRAPPED';
export const SPAN_FOR_COMPONENT_RENDERED = 'RENDERED';
export const SPAN_FOR_COMPONENT_DOM_READY = 'DOM_READY';
export const SPAN_FOR_COMPONENT_PROPERTY_CHANGED = 'PROPERTY_CHANGED';
export const SPAN_FOR_COMPONENT_RENDER_REQUESTED = 'RENDER_REQUESTED';
export const SPAN_FOR_COMPONENT_DOM_TREE_READY = 'DOM_TREE_READY';
export const SPAN_FOR_COMPONENT_TREE_RENDERED = 'TREE_RENDERED';
export const SPAN_FOR_COMPONENT_ERROR_THROWN = 'ERROR_THROWN';
export const SPAN_LIFECYCLE_EVENTS = {
	[actionTypes.COMPONENT_CONNECTED]: SPAN_FOR_COMPONENT_CONNECTED,
	[actionTypes.COMPONENT_DISCONNECTED]: SPAN_FOR_COMPONENT_DISCONNECTED,
	[actionTypes.COMPONENT_BOOTSTRAPPED]: SPAN_FOR_COMPONENT_BOOTSTRAPPED,
	[actionTypes.COMPONENT_RENDERED]: SPAN_FOR_COMPONENT_RENDERED,
	[actionTypes.COMPONENT_DOM_READY]: SPAN_FOR_COMPONENT_DOM_READY,
	[actionTypes.COMPONENT_PROPERTY_CHANGED]: SPAN_FOR_COMPONENT_PROPERTY_CHANGED,
	[actionTypes.COMPONENT_RENDER_REQUESTED]: SPAN_FOR_COMPONENT_RENDER_REQUESTED,
	[actionTypes.COMPONENT_DOM_TREE_READY]: SPAN_FOR_COMPONENT_DOM_TREE_READY,
	[actionTypes.COMPONENT_TREE_RENDERED]: SPAN_FOR_COMPONENT_TREE_RENDERED,
	[actionTypes.COMPONENT_ERROR_THROWN]: SPAN_FOR_COMPONENT_ERROR_THROWN
};

export const SPAN_ATTR_COMPONENT_CONNECTED = 'connected';
export const SPAN_ATTR_COMPONENT_SUSPENDED = 'suspended';
export const SPAN_ATTR_COMPONENT_DETACHED = 'detached';
export const SPAN_ATTR_COMPONENT_INTERSECTED = 'intersected';
export const SPAN_ATTR_COMPONENT_RENDER_SKIPPED = 'renderSkipped';
export const SPAN_ATTR_COMPONENT_EVENT_DEFAULT_PREVENTED = 'defaultPrevented';
export const SPAN_ATTR_COMPONENT_EVENT_PROPAGATION_STOPPED = 'propagationStopped';
export const SPAN_ATTR_DISPATCH_ACTION_TYPE = 'actionType';
export const SPAN_ATTR_DISPATCH_ACTION_INTERNAL_TYPE = 'internalActionType';
export const SPAN_ATTR_DISPATCH_PAYLOAD = 'payload';
export const SPAN_ATTR_DISPATCH_SHOULD_DISPATCH = 'shouldDispatch';
export const SPAN_ATTR_DISPATCH_UNDEFINED = 'isActionUndefined';
export const SPAN_ATTR_DISPATCH_FLAG_HOST_DISPATCH = 'undocumentedHostDispatch';
export const SPAN_ATTR_UPDATE_PROPERTIES_SHOULD_UPDATE = 'shouldUpdate';
export const SPAN_ATTR_UPDATE_PROPERTIES_PROPNAME = 'propertyName';
export const SPAN_ATTR_UPDATE_PROPERTIES_PROPVALUE = 'propertyValue';
export const SPAN_ATTR_UPDATE_PROPERTIES_PROP = 'property';

export const SPAN_ATTR_SET_PROPERTY_SKIPED = 'setSkipped';
export const SPAN_ATTR_UPDATE_CONTEXT_SHOULD_BATCH = 'shouldBatch';

export const SPAN_ATTR_RENDER_CAUSE = 'renderCause';
export const SPAN_ATTR_UPDATE_PAYLOAD = 'updatePayload';
export const SPAN_ATTR_DID_UPDATE = 'didUpdate';
export const SPAN_ATTR_SHOULD_RENDER = 'shouldRender';

export const SPAN_ATTR_TASK_SCHEDULED = 'taskScheduled';
export const SPAN_ATTR_TASK_STARTED = 'taskStarted';
export const SPAN_ATTR_TASK_DEDUPED = 'taskDeduped';
export const SPAN_ATTR_TASK_COMPLETED = 'taskCompleted';

export const SPAN_ATTR_CONDITIONAL = 'conditional';
export const SPAN_ATTR_SKIP_FOR_DETACHED_COMPONENT = 'skipForDetachedComponent';
export const SPAN_ATTR_STORE_UPDATE = 'storeUpdate';
